import { Controller } from "@hotwired/stimulus";

// Plays the surface entrance on connect. Pair with class="entrance".
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => this.element.classList.add("in"));
  }
}
